import React from "react";
import { RouteComponentProps } from "react-router-dom";

import { createPromoArts } from "v2/api/mutations/application/promoArts";

import { ReferenceVariationType } from "api/models";
import { StepData } from "components/application/forms/PromoArtStep";
import ApplicationUpdateContainer from "../ApplicationUpdateContainer";
import ApplicationUpdatePromoArtsPage from "./ApplicationUpdatePromoArtsPage";

import { useFullPageLoader } from "v2/hooks/useFullPageLoader";

interface Props extends RouteComponentProps<{ id: string }> {}

function ApplicationUpdatePromoArtsContainer(props: Props) {
  const [fullPageLoader, setIsLoading] = useFullPageLoader();

  const handleOnSubmit = (onSubmitFunc: any) => async (formData: StepData) => {
    setIsLoading(true);
    await onSubmitFunc({
      data: formData.assets.map((d) => ({
        isControl: d === formData.control,
      })),
      files: formData.assets.map((d) => d.file),
      referenceVariationType:
        formData.referenceVariationType || ReferenceVariationType.top,
    });
    setIsLoading(false);
  };

  return (
    <>
      {fullPageLoader}
      <ApplicationUpdateContainer
        {...props}
        mutation={createPromoArts.definition}
      >
        {(application: any, onDiscard: () => void, onSubmit: () => void) => (
          <ApplicationUpdatePromoArtsPage
            onDiscard={onDiscard}
            onSubmit={handleOnSubmit(onSubmit)}
            isEdit={true}
            application={application}
          />
        )}
      </ApplicationUpdateContainer>
    </>
  );
}

export default ApplicationUpdatePromoArtsContainer;
